export const mapSetters = (state, setters = {}) => {
  return Object.keys(state).reduce((acc, key) => {
    acc[key] = {
      get: state[key],
    }
   
    if (setters[key]) {
      acc[key].set = setters[key]
    }
    return acc
  }, {})
}


// WEBPACK FOOTER //
// ./src/store/util.js